import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../Loader/LoaderSlice';
import { setApiError } from '../Error/ErrorSlice';
import { fireApi } from '../../../utils/FireApi';
import { PayoutApi } from '../../../utils/Apis';
import { resetStore } from '../../Actions';

const initialState = {
  list_data: null,
  view_data: null,
  comment_log: null,
  advance_list_data: null,
  summary_list_data: null,
  network_list_data: null,
  advance_pending_list_data: null,
  pl_list_data: null,
  profile_list_data: null,
  payment_method: null
};

const PayoutSlice = createSlice({
  name: 'Payout',
  initialState,
  reducers: {
    setPayoutGrid(state, action) {
      state.list_data = action.payload;
    },
    setPayoutView(state, action) {
      state.view_data = action.payload;
    },
    setCommentLogs(state, action) {
      state.comment_log = action.payload;
    },

    setAdvancePayoutGrid(state, action) {
      state.advance_list_data = action.payload;
    },
    setSummaryGrid(state, action) {
      state.summary_list_data = action.payload;
    },
    setNetworkGrid(state, action) {
      state.network_list_data = action.payload;
    },
    setAdvancePendingView(state, action) {
      state.advance_pending_list_data = action.payload;
    },
    setPLGrid(state, action) {
      state.pl_list_data = action.payload;
    },
    setProfileGrid(state, action) {
      state.profile_list_data = action.payload;
    },
    setPaymentMethod(state, action) {
      state.payment_method = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
  }
});

// Payout List
export const getPayoutList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: PayoutApi?.payoutList,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setPayoutGrid(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setPayoutGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Payout List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Payout List exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Payout view
export const getPayoutViewData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: PayoutApi?.payoutView,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setPayoutView(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setPayoutView(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Payout view failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Payout view exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Payout comment log
export const getPayoutCommentLogs = (id) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: PayoutApi?.payoutCommentLogs(id)
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setCommentLogs(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setCommentLogs(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Payout comment log failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Payout comment log exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// upload
export const savefileApiData = (endpoint, data, token) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint,
      method: 'post',
      payload: data,
      extraHeaders: {
        // Let Axios set the boundary automatically
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`
      }
    });

    if (res?.success) {
      // dispatch(setApiError('Data uploaded successfully !'));
      return res;
    } else {
      dispatch(setApiError(res?.message || res?.error || 'Something went wrong'));
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Payout List
export const getAdvancePayoutList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: PayoutApi?.pendingAdvancePayout,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setAdvancePayoutGrid(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setAdvancePayoutGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Payout List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Payout List exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// summary List
export const getSummaryList =
  ({ userId }) =>
  async (dispatch) => {
    dispatch(setIsLoading({ loading: true }));
    try {
      const res = await fireApi({
        endpoint: `${PayoutApi?.payoutSummary}/${userId}`,
        method: 'get',
        payload: userId
      });
      // console.log('res2222', res);
      // 🔹 Handle success
      if (res?.success) {
        dispatch(setSummaryGrid(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
        return res?.data;
      } else {
        dispatch(setSummaryGrid(null)); // store in redux
        dispatch(setApiError(res?.message || 'Something went wrong'));
        console.error('❌ SummaryGrid  failed rrrrr', res?.data?.error);
        return null;
      }
    } catch (error) {
      dispatch(setApiError('Something went wrong'));
      console.error('🔥 SummaryGrid  exception rrrrr', error);
      return null;
    } finally {
      dispatch(setIsLoading({ loading: false }));
    }
  };

// network List
export const getNetworkList =
  ({ userId }) =>
  async (dispatch) => {
    dispatch(setIsLoading({ loading: true }));
    try {
      const res = await fireApi({
        endpoint: `${PayoutApi?.payoutNetwork}/${userId}`,
        method: 'get',
        payload: userId
      });
      // console.log('sss network', res);
      // 🔹 Handle success
      if (res?.success) {
        dispatch(setNetworkGrid(res?.data ? res?.data : res?.data)); // store in redux
        return res?.data;
      } else {
        dispatch(setNetworkGrid(null)); // store in redux
        dispatch(setApiError(res?.message || 'Something went wrong'));
        console.error('❌ network  failed rrrrr', res?.data?.error);
        return null;
      }
    } catch (error) {
      dispatch(setApiError('Something went wrong'));
      console.error('🔥 network  exception rrrrr', error);
      return null;
    } finally {
      dispatch(setIsLoading({ loading: false }));
    }
  };

// PL List
export const getPLList =
  ({ userId }) =>
  async (dispatch) => {
    dispatch(setIsLoading({ loading: true }));
    try {
      const res = await fireApi({
        endpoint: `${PayoutApi?.payoutPL}/${userId}`,
        method: 'get',
        payload: userId
      });
      console.log('sss PL list', res);
      // 🔹 Handle success
      if (res?.success) {
        dispatch(setPLGrid(res?.data ? res?.data : res?.data)); // store in redux
        return res?.data;
      } else {
        dispatch(setPLGrid(null)); // store in redux
        dispatch(setApiError(res?.message || 'Something went wrong'));
        console.error('❌ PL  failed rrrrr', res?.data?.error);
        return null;
      }
    } catch (error) {
      dispatch(setApiError('Something went wrong'));
      console.error('🔥 PL  exception rrrrr', error);
      return null;
    } finally {
      dispatch(setIsLoading({ loading: false }));
    }
  };

// advance pending List
export const getAdvancePendingViewList = (credentials) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: `${PayoutApi?.advancePendingView}`,
      method: 'post',
      payload: credentials
    });
    // console.log('sss getAdvancePendingViewList', res);
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setAdvancePendingView(res?.data ? res?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setAdvancePendingView(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ network  failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 network  exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// profile List
export const getProfileList =
  ({ userId }) =>
  async (dispatch) => {
    dispatch(setIsLoading({ loading: true }));
    try {
      const res = await fireApi({
        endpoint: `${PayoutApi?.payoutProfile}/${userId}`,
        method: 'get',
        payload: userId
      });
      // console.log('prfile res2222', res);
      // 🔹 Handle success
      if (res?.success) {
        dispatch(setProfileGrid(res?.data?.summary ? res?.data?.summary?.profile : res?.data)); // store in redux
        return res?.data;
      } else {
        dispatch(setProfileGrid(null)); // store in redux
        dispatch(setApiError(res?.message || 'Something went wrong'));
        console.error('❌ setProfileGrid  failed ', res?.data?.error);
        return null;
      }
    } catch (error) {
      dispatch(setApiError('Something went wrong'));
      console.error('🔥 setProfileGrid  exception ', error);
      return null;
    } finally {
      dispatch(setIsLoading({ loading: false }));
    }
  };

// Get Payment Method
export const getPaymentMethod = (id) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: PayoutApi?.getPaymentMethod(id),
      method: 'get'
    });

    if (res?.success) {
      dispatch(setPaymentMethod(res?.data?.data ? res?.data?.data : res?.data));
      return res?.data;
    } else {
      dispatch(setPaymentMethod(null));
      // dispatch(setApiError(res?.message || 'Something went wrong'));
      return null;
    }
  } catch (error) {
    // dispatch(setApiError('Something went wrong'));
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Create Payment Method
export const createPaymentMethod = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: PayoutApi?.createPaymentMethod,
      method: 'post',
      payload: data
    });

    if (res?.success) {
      dispatch(setApiError(res?.message || 'Payment method created successfully'));
      return res?.data;
    } else {
      dispatch(setApiError(res?.message || 'Something went wrong'));
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Update Payment Method
export const updatePaymentMethod = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: PayoutApi?.updatePaymentMethod,
      method: 'post', // The user curl said --request POST/data-raw for update too, though update is usually PUT. Following user request.
      payload: data
    });

    if (res?.success) {
      dispatch(setApiError(res?.message || 'Payment method updated successfully'));
      return res?.data;
    } else {
      dispatch(setApiError(res?.message || 'Something went wrong'));
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const {
  setPayoutGrid,
  setPayoutView,
  setSummaryGrid,
  setCommentLogs,
  setAdvancePayoutGrid,
  setNetworkGrid,
  setAdvancePendingView,
  setPLGrid,
  setProfileGrid,
  setPaymentMethod
} = PayoutSlice.actions;
export default PayoutSlice.reducer;
